import { apiService } from './api';

export interface SalesItemDTO {
  salesItemId: number;
  productId: number;
  productSKU: string;
  productName: string;
  sellingPrice: number;
  minimumSellingPrice?: number;
  currency: string;
  discountAllowed: boolean;
  warrantyPeriod?: string;
  returnAllowed: boolean;
  returnPeriodDays?: number;
  salesChannel: string;
  isActive: boolean;
  createdDate: string;
  taxId?: number;
  taxCode?: string;
  taxName?: string;
  taxPercentage?: number;
}

export interface CreateSalesItemRequest {
  productId: number;
  sellingPrice: number;
  minimumSellingPrice?: number;
  currency: string;
  discountAllowed: boolean;
  warrantyPeriod?: string;
  returnAllowed: boolean;
  returnPeriodDays?: number;
  salesChannel: string;
  taxId?: number;
}

export interface UpdateSalesItemRequest {
  sellingPrice: number;
  minimumSellingPrice?: number;
  currency: string;
  discountAllowed: boolean;
  warrantyPeriod?: string;
  returnAllowed: boolean;
  returnPeriodDays?: number;
  salesChannel: string;
  isActive: boolean;
  taxId?: number;
}

const SALES_ITEMS_API = '/sales-items';

export const salesItemService = {
  getSalesItems: (pageNumber = 1, pageSize = 50) =>
    apiService.get<any>(SALES_ITEMS_API, { pageNumber, pageSize }),

  getSalesItemById: (id: number) =>
    apiService.get<SalesItemDTO>(`${SALES_ITEMS_API}/${id}`),

  getSalesItemsByProduct: (productId: number) =>
    apiService.get<SalesItemDTO[]>(`${SALES_ITEMS_API}/product/${productId}`),

  createSalesItem: (data: CreateSalesItemRequest) =>
    apiService.post<SalesItemDTO>(SALES_ITEMS_API, data),

  updateSalesItem: (id: number, data: UpdateSalesItemRequest) =>
    apiService.put<SalesItemDTO>(`${SALES_ITEMS_API}/${id}`, data),

  deleteSalesItem: (id: number) =>
    apiService.delete<void>(`${SALES_ITEMS_API}/${id}`),
};
